import { DateUtil } from "@dto/util/DateUtil";
import { forwardRef, useMemo } from "react";
import DeferredRangePicker from './DeferredRangePicker';
import { fromDisplayTz, type AntdValue, type XmRangeDatePickerProps, type XmRangeDatePickerRef } from './rangePickerAntd';
import { RANGE_DATE_PICKER_DEFAULT_PRESETS } from './rangePickerPresets';
import StockRangePicker from './StockRangePicker';
import './XmRangeDatePicker.less';

export type { XmRangeDatePickerProps, XmRangeDatePickerRef };

const toDisplayTz = (range: NonNullable<AntdValue>): NonNullable<AntdValue> =>
  [DateUtil.toDisplayTz(range[0]), DateUtil.toDisplayTz(range[1])];

const XmRangeDatePicker = forwardRef<XmRangeDatePickerRef, XmRangeDatePickerProps>((props, ref) => {
  const { value, defaultValue, onChange } = props;
  // Both pickers read controlled mode from the key's presence and re-sync on every new `value` identity.
  const displayValue = useMemo(() => value && toDisplayTz(value), [value]);
  const merged: XmRangeDatePickerProps = {
    presets: RANGE_DATE_PICKER_DEFAULT_PRESETS,
    format: DateUtil.DATETIME_FORMAT,
    ...props,
    ...('value' in props && { value: displayValue }),
    defaultValue: defaultValue && toDisplayTz(defaultValue),
    onChange: onChange && ((range, dateStrings) => onChange(range && fromDisplayTz(range), dateStrings)),
  };
  const deferred = !!merged.showTime || merged.picker === 'time';
  return deferred ? <DeferredRangePicker {...merged} ref={ref} /> : <StockRangePicker {...merged} ref={ref} />;
});

export default XmRangeDatePicker;
